import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <div className="bg-slate-900">
        <div className="container mx-auto px-5">
          <div className="footer pt-24">
            <div className="container px-4 mx-auto">
              <div className="md:flex md:flex-wrap md:-mx-4 py-6 md:pb-12">
                <div className="footer-info lg:w-1/3 md:px-4">
                  <img className="h-16 mb-5" src="images/logo.png" alt="logo" />
                  <p className="text-gray-400">
                    Need to talk to someone? Contact us
                  </p>
                  <div className="mt-7">
                    <h3 className="text-xl font-bold text-white pb-5">
                      Follow
                    </h3>
                    <div className="flex">
                      <a
                        href="/"
                        className="bg-primary p-2 rounded-full text-white text-xl mr-4"
                      >
                        <FaFacebook />
                      </a>
                      <a
                        href="/"
                        className="bg-primary p-2 rounded-full text-white text-xl mr-4"
                      >
                        <FaTwitter />
                      </a>
                      <a
                        href="/"
                        className="bg-primary p-2 rounded-full text-white text-xl mr-4"
                      >
                        <FaLinkedin />
                      </a>
                      <a
                        href="/"
                        className="bg-primary p-2 rounded-full text-white text-xl mr-4"
                      >
                        <FaInstagram />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="md:w-2/3 lg:w-1/3 md:px-4 xl:pl-16 mt-12 lg:mt-0">
                  <div className="sm:flex">
                    <div className="sm:flex-1">
                      <h6 className="text-base font-medium text-white uppercase mb-2">
                        Useful Links
                      </h6>
                      <div>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          About
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Contact
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Blog
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Services
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Our Team
                        </a>
                      </div>
                    </div>
                    <div className="sm:flex-1 mt-4 sm:mt-0">
                      <h6 className="text-base font-medium text-white uppercase mb-2">
                        Learn More
                      </h6>
                      <div>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Lorem ipsum dolor
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Lorem ipsum dolor
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Lorem ipsum dolor
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Lorem ipsum dolor
                        </a>
                        <a
                          href="/"
                          className="text-gray-400 py-1 block hover:underline"
                        >
                          Lorem ipsum dolor
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="md:w-1/3 md:px-4 md:text-center mt-12 lg:mt-0">
                  <h5 className="text-lg text-white font-medium mb-4">
                    Sign up for email updates
                  </h5>
                  <a href="/" className="btn">
                    Sign Up
                  </a>
                </div>
              </div>
            </div>

            <div className="border-t border-solid border-gray-600 py-4">
              <div className="container px-4 mx-auto">
                <div className="md:flex md:-mx-4 md:items-center">
                  <div className="md:flex-1 md:px-4  md:text-left">
                    <p className="text-white text-center">
                      &copy;
                      <strong>
                        2022, Avio Marketing. All Rights Reserved.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
